/* eslint-disable no-nested-ternary */
import styled from "styled-components";
import { bpMax, getGlobalCSSVariants } from "theme";

export const Container = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	overflow-x: auto;
	overflow-y: hidden;
	margin-left: 8px;
	// padding-right: 10px;
	-ms-overflow-style: none;
	scrollbar-width: none;
	&::-webkit-scrollbar {
		display: none;
	}
	> * + * {
		margin-left: 8px;
	}
`;

export const Chip = styled.div<{ selected: boolean; isVIHost?: string }>`
	display: flex;
	align-items: center;
	cursor: pointer;
	min-width: fit-content;
	background: ${({ selected }) => (selected ? "#4D3951" : "#ffffff")};
	border: 1px solid ${({ selected }) => (selected ? "#827485" : "#E8E7EA")};
	border-radius: 100px;
	padding: 6px 12px;
	font-size: 14px;
	line-height: 20px;
	color: ${({ selected }) => (selected ? "#ffffff" : "#190a28")};
	user-select: none;
	${bpMax.md} {
		background: ${({ selected, isVIHost }) =>
			selected
				? getGlobalCSSVariants(isVIHost).primaryChipSelectionColor
				: "#ffffff"};
		border: 1px solid
			${({ selected, isVIHost }) =>
				selected
					? getGlobalCSSVariants(isVIHost).primaryChipSelectionBorderColor
					: "#E8E7EA"};
	}
	> * + * {
		margin-left: 8px;
	}
`;

export const IconContainer = styled.span`
	height: 20px;
	width: 20px;

	svg {
		height: 100%;
		width: 100%;
	}
`;

export const Separator = styled.div`
	display: block;
	width: 1px;
	height: 32px;
	border-right: 1px solid #e8e7ea;
`;

export const ChipContainer = styled.div<{ isDesktopView: boolean }>`
	&::after {
		content: "";
		position: absolute;
		top: 0;
		right: ${(props) => (props.isDesktopView ? "100px" : "0px")};
		bottom: 0;
		min-width: 181px;
		height: 52px;
		background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
		pointer-events: none;
	}
`;

// export const GradientComponent = styled.div`
// 	position: sticky;
// 	min-width: 100px;
// 	height: 40px;
// 	right: 0px;
// 	z-index: 5;
// 	background: linear-gradient(270deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
// 	${bp.md} {
// 		position: absolute;
// 	}
// `;
